import lockScroll from '../__utils/lockScroll';

class EventsFilters {
	constructor() {
		this.button = document.querySelector(
			'.tribe-events-c-events-bar__filter-button'
		);
		this.buttonClose = document.querySelector('.tribe-filter-bar__close');
		this.buttonDone = document.querySelector(
			'.tribe-filter-bar__action-done.c-btn-primary'
		);
	}

	init() {
		if (this.button) {
			window.document.addEventListener('click', (e) => {
				if (
					e.target === this.button ||
					e.target.closest('button') === this.button
				) {
					if (this.button.getAttribute('aria-expanded') === 'true') {
						lockScroll.lock();
					}
				}

				if (
					e.target === this.buttonDone ||
					e.target === this.buttonClose ||
					e.target.closest('button') === this.buttonDone ||
					e.target.closest('button') === this.buttonClose
				) {
					if (this.button.getAttribute('aria-expanded') === 'false') {
						lockScroll.unlock();
					}
				}
			});
		}
	}

	resized() {
		if (
			this.button?.ariaExpanded === 'true' &&
			window.matchMedia('screen and (min-width: 767px)').matches
		) {
			this.button.ariaExpanded = 'false';
			lockScroll.unlock();
		}
	}
}
export default new EventsFilters();
